export default __webpack_public_path__ + "static/media/DEX-LP.b847b21a.png";